import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import { FaEnvelope, FaLock, FaSignInAlt } from 'react-icons/fa';
import { auth} from '../../services/firebaseConnection';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import '../../responsive.css';
import logoBranca from '../../assets/logo-branca.png';
import { getDoc, collection, doc } from 'firebase/firestore';
import { db } from '../../services/firebaseConnection';
import { AuthContext } from "../../contexts/AuthContext";
import { useContext } from "react";
import { toast } from 'react-toastify';

export default function Auth() {

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const navigate = useNavigate();
  const {userFirebase, setUserFirebase } = useContext(AuthContext);

useEffect(()=>{
  async function handleLogOut() {
    await signOut(auth)
      .then(() => {
        localStorage.removeItem("@userFirebase"); // Limpa os dados salvos
        navigate('/login', { replace: true });
      })
      .catch((error) => {
        toast.error('Erro ao deslogar: ' + error.message);
      });
  }

  handleLogOut() 
}, [])

  const handleSubmit = async (e) => {
  e.preventDefault();
  setErro('');
  
  if (!email || !senha) {
    setErro('Por favor, preencha todos os campos');
    return;
  }

  setCarregando(true);

  signInWithEmailAndPassword(auth, email, senha)
    .then(async (user) => {
      
        const userData = user.user.uid;

        const docRef = doc(db, "users", userData); // referência ao documento do usuário
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {

          setUserFirebase(docSnap.data());
          localStorage.setItem("@userFirebase", JSON.stringify(docSnap.data())); 

        } else {
          toast.error("Usuário não encontrado!");
        }



      
      navigate("/dashboard", { replace: true });
    })
    .catch(err => {
      console.log(err);
      setErro('Credenciais inválidas');
      setCarregando(false);
    });


};


  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src={logoBranca} alt="" className='img-logo'/>
        </div>
        <div className="login-body">
          <h3 className="login-title">Login</h3>
          
          {erro && (
            <Alert variant="danger" className="mb-3">
              {erro}
            </Alert>
          )}
          
          <Form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                <FaEnvelope className="me-2" /> Email
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Seu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="senha" className="form-label">
                <FaLock className="me-2" /> Senha
              </label>
              <input
                type="password"
                id="senha"
                className="form-control"
                placeholder="Sua senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
            </div>
            
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="lembrar"
                />
                <label className="form-check-label" htmlFor="lembrar">
                  Lembrar-me
                </label>
              </div>
              <Link to="/esqueci-senha" className="text-primary">
                Esqueceu a senha?
              </Link>
            </div>
            
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={carregando}
            >
              {carregando ? (
                'Entrando...'
              ) : (
                <>
                  <FaSignInAlt className="me-2" /> Entrar
                </>
              )}
            </button>
          </Form>
        </div>
        <div className="login-footer">
          <p className="mb-0">
            © {new Date().getFullYear()} Maxtra Mídia
          </p>
        </div>
      </div>
    </div>
  );
};



